import Translation from "components/Translation"
import React from "react"
import { FeatureFlagTypes } from "components/SupportSettingsToggler/types"
import { Roles } from "app/models/user"
import { EmployeeSettingsRoutes } from "app/routes/types"

export default [
  {
    id: EmployeeSettingsRoutes.EmployeeDetail,
    label: <Translation label="employee.settings.tab.personal.title" />,
  },
  {
    id: EmployeeSettingsRoutes.ContractDetail,
    label: <Translation label="employee.settings.tab.contract" />,
    accessRoles: [Roles.Planner, Roles.HROfficer],
  },
  {
    id: EmployeeSettingsRoutes.LeaveEntitlementsDetail,
    label: <Translation label="employee.settings.tab.leave" />,
    featureRestriction: FeatureFlagTypes.ShowLeaveCounters,
    accessRoles: [Roles.Planner, Roles.HROfficer],
  },
]
